import { useRef, useMemo } from 'preact/hooks';
import dayjs from 'dayjs';
import { calculateAvailabilityWindow } from '../utils';

const useAvailabilityWindow = (currentMonth) => {
  const loadedWindowsRef = useRef([]);

  const availabilityWindow = useMemo(() => {
    if (!currentMonth) return null;
    const m = dayjs(currentMonth).startOf('month');

    const existing = loadedWindowsRef.current.find(w => {
      const windowStart = dayjs(w.from).startOf('month');
      const windowEnd = dayjs(w.to).startOf('month');
      return !m.isBefore(windowStart) && !m.isAfter(windowEnd);
    });
    if (existing) return existing;

    const now = new Date();
    const isCurrentMonth =
      currentMonth.getFullYear() === now.getFullYear() &&
      currentMonth.getMonth() === now.getMonth();
    const windowAnchor = isCurrentMonth ? now : currentMonth;

    const newWindow = calculateAvailabilityWindow(windowAnchor);
    loadedWindowsRef.current = [...loadedWindowsRef.current, newWindow];
    return newWindow;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentMonth?.getFullYear(), currentMonth?.getMonth()]);

  const resetWindows = () => {
    loadedWindowsRef.current = [];
  };

  return { availabilityWindow, resetWindows };
};

export default useAvailabilityWindow;
